import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownItem } from '@digitsolu/ui-tailwind';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { OKTA_AUTH } from '@okta/okta-angular';
import { AuthnTransaction, OktaAuth } from '@okta/okta-auth-js';
import { environment } from 'apps/app-cic-ciam/src/environments/environment';
import { SupportService } from 'apps/app-cic-ciam/src/services/support.service';
import { Observable } from 'rxjs';
import {
  ClearEverything,
  ClearLoginCredentials,
  ClearOAuthSigninRequest,
  SetLanguage,
} from '../../app.actions';
import { StateModel, STATE_TOKEN } from '../../app.states';

const DEFAULT_ORIGINAL_URI = window.location.origin;

@Component({
  selector: 'digitsolu-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent {
  user: string = '';
  credential = new EventEmitter<{ email: string; password: string }>();

  state: string = ''; //=WVNGL3grSERUdFJTVFNibFBsWG91cUZzMkxaUEgxMDBoczJncGlzWmdCUDI5Wkk2Nmx0bmM3end4YVJremtsUA&
  nonce: string = ''; //=tphLFY7GlJssurM4nh4s30rzhAMfciCk&
  code_challenge: string = ''; //=SDr1LUqoRgPsTxe336MVhzrRjhAGcWjnaj4W1bSw5Ew&
  code_challenge_method: string = ''; //=S256&
  client_id: string = ''; //=0oa4cd4j2gVdXd0Ac697&
  redirect_uri: string = ''; //=https%3A%2F%2Fonepass-sso-uat.cic.hk%2Foauth2%2Fv1%2Fauthorize%2Fcallback&
  response_type: string = ''; //=code&
  display: string = ''; //=page&
  scope: string = ''; //=email+openid+profile

  callback: string = ''; //=https%3A%2F%2Fapps.cic.hk%2Fhkicopas%2FRegistrationSuccess

  verificationToken?: string;
  loginApp?: string;

  showSuccessMessage: boolean = false;

  @Select(STATE_TOKEN) appState$!: Observable<StateModel>;

  public readonly items: DropdownItem[][] = [
    [
      {
        name: '繁體中文',
        onClick: ($event) => {
          $event.preventDefault();
          this.translate.use('zh-Hant');
          this.store.dispatch(new SetLanguage('zh-Hant'));
        },
      },
    ],
    [
      {
        name: '简体中文',
        onClick: ($event) => {
          $event.preventDefault();
          this.translate.use('zh-Hans');
          this.store.dispatch(new SetLanguage('zh-Hans'));
        },
      },
    ],
    [
      {
        name: 'English',
        onClick: ($event) => {
          $event.preventDefault();
          this.translate.use('en');
          this.store.dispatch(new SetLanguage('en'));
        },
      },
    ],
  ];

  constructor(
    private router: Router,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private route: ActivatedRoute,
    private http: HttpClient,
    private store: Store,
    private supportService: SupportService,
    public translate: TranslateService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.state = params['state'];
      this.nonce = params['nonce'];
      this.code_challenge = params['code_challenge'];
      this.code_challenge_method = params['code_challenge_method'];
      this.client_id = params['client_id'];
      this.redirect_uri = params['redirect_uri'];
      this.response_type = params['response_type'];
      this.display = params['display'];
      this.scope = params['scope'];

      this.callback = params['callback'];
    });

    this.store.subscribe((state) => {
      this.loginApp = state.cicciam.loginApp;
    });

    this.store.dispatch(new ClearEverything());
  }

  async ngOnInit() {
    // Check for 'language' cookie and set language if present
    const getCookie = (): string | undefined => {
      const match = document.cookie.match(new RegExp('(^| )language=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : undefined;
    };
    const lang = getCookie();
    if (lang) {
      this.translate.use(lang);
      this.store.dispatch(new SetLanguage(lang));
    }
  }

  onRegister = async (payload: any) => {

    if (payload.isSuccess) {
    console.log(`payload.isSuccess: ${JSON.stringify(payload.data)}`);

    // Show success message and close window after 8 seconds
    this.showSuccessMessage = true;

    if(this.callback){
      setTimeout(() => {
        window.location.href = decodeURIComponent(this.callback);
      }, 5000); // 5-second delay
    } else {
      setTimeout(() => {
        window.close();
      }, 5000); // 5-second delay
    }

    this.store.dispatch(new ClearLoginCredentials());

    if (this.loginApp) {
      await this.supportService.assignUserGroupByApp(this.loginApp);
    }

    return;
  }

    // if (payload.isSuccess) {
    //   // window.close();
    //   console.log(`payload.isSuccess: ${JSON.stringify(payload.data)}`);

    //     this.showSuccessMessage = true;

    //     setTimeout(() => {
    //       window.close();
    //     }, 8000); // 8-second delay

    //   // this.store.dispatch(new Authenticate(payload.data.value));
    //   // this.store.dispatch(
    //   //   new StoreLoginCredentials(payload.email, payload.password)
    //   // );

    //   // const authResponse = payload.data.value;
    //   const response = payload.data;
    //   const userId = payload.data.userId;

    //   // if (response && response.authenticationStatus.value == 'SUCCESS') {
    //   if (response && response.success) {

    //     if (this.loginApp) {
    //       await this.supportService.assignUserGroupByApp(this.loginApp);
    //     }

    //     this.store.dispatch(new ClearLoginCredentials());

    //     switch (this.loginApp) {
    //       case 'opasdev':
    //         location.href =
    //           'https://cic-dev.outsystemsenterprise.com/onlineProgramApplication/RegistrationSuccess?uid=' +
    //           userId;
    //         break;
    //       case 'opasuat':
    //         location.href =
    //           'https://cic-tst.outsystemsenterprise.com/onlineProgramApplication/RegistrationSuccess?uid=' +
    //           userId;
    //         break;
    //       case 'opas':
    //         location.href =
    //           'https://apps.cic.hk/hkicopas/RegistrationSuccess?uid=' + userId;
    //         break;
    //       case 'superapp':
    //         const sessionToken = response.sessionToken;

    //         if (this.state && this.redirect_uri && sessionToken) {
    //           this.store.dispatch(new ClearOAuthSigninRequest());
    //           this.supportService
    //             .createTokenRecord(sessionToken ?? '', this.state, this.redirect_uri)
    //             .then((result) => {
    //               console.log(result);
    //               window.location.href =
    //                 'https://' +
    //                 environment.oktaDomain +
    //                 '/oauth2/v1/authorize?response_type=token&scope=openid%20profile%20offline_access%20email&nonce=TEST&client_id=' +
    //                 environment.idpReturnAppId +
    //                 '&redirect_uri=https:%2F%2F' +
    //                 window.location.hostname +
    //                 '%2Flogin%2Fcallback&sessionToken=' +
    //                 sessionToken +
    //                 '&state=' +
    //                 result.state;
    //             });
    //         } else {
    //           // this.oktaAuth.session.setCookieAndRedirect(
    //           //   sessionToken,
    //           //   window.location.protocol + '//' + window.location.host + '/home'
    //           // );
    //           this.router.navigate(['/portallogin']);
    //         }
    //         break;
    //       default:
    //         this.router.navigate(['/portallogin']);
    //     }
    //   }
    //   // Sets a cookie on redirect
    //   // if (payload.email && !payload.email.endsWith('@cicciam.hk')) {
    //   //   try {
    //   //     let result = await this.supportService.enable2FaEmail(
    //   //       true,
    //   //       this.translate.currentLang,
    //   //       payload.email
    //   //     );
    //   //     console.log(result);
    //   //     // TODO: check if success in return
    //   //     this.store.dispatch(new EmailEnrollResponse(result));
    //   //   } catch (e) {
    //   //     this.store.dispatch(new EmailEnrollResponse(e));
    //   //   }
    //   // } else {
    //   //   this.store.dispatch(new EmailEnrollResponse(null));
    //   // }

    //   // if (payload.mobilePhone) {
    //   //   if (
    //   //     payload.mobilePhone.length == 8 &&
    //   //     !payload.mobilePhone.startsWith('+')
    //   //   ) {
    //   //     payload.mobilePhone = '+852' + payload.mobilePhone;
    //   //   }
    //   //   try {
    //   //     let result = await this.supportService.enable2FaSms(
    //   //       true,
    //   //       this.translate.currentLang,
    //   //       payload.mobilePhone
    //   //     );
    //   //     console.log(result);
    //   //     // TODO: check if success in return
    //   //     this.store.dispatch(new SmsEnrollResponse(result));
    //   //   } catch (e) {
    //   //     this.store.dispatch(new SmsEnrollResponse(e));
    //   //   }
    //   // } else {
    //   //   this.store.dispatch(new SmsEnrollResponse(null));
    //   // }

    //   // this.router.navigate(['register-validate']);
    // }
  };

  onLogin() {
    this.router.navigate(['login']);
  }

  goToLogin() {
    // try close itself
    window.close();
    // fallback to redirect
    this.router.navigate(['login']);
  }
}
